import React from 'react';
import {Map} from 'immutable';

import Match from './Match.jsx';
import {cssClassMap} from 'rendering-commons/SportCssMap';

export default class League extends React.Component {
    static propTypes = {
        league: React.PropTypes.instanceOf(Map).isRequired,
        sport: React.PropTypes.instanceOf(Map).isRequired,
        matches: React.PropTypes.array.isRequired
    };

    render() {
        const {sport, league, matches} = this.props;

        const sportId = sport.get('id');
        const sportName = sport.get('name');
        const leagueName = league.get('name');

        const sportCssName = cssClassMap[sportId];

        let leagueClass = 'schedule league ' + sportCssName;
        let titleClass = 'title';

        const sportIconClass = 'schedule sport-icon svg-' + sportCssName;

        return (
            <div className={leagueClass}>
                <div className={titleClass}>
                    <span className={sportIconClass}/>
                    <strong>{sportName + '. '}</strong>
                    <span>{leagueName}</span>
                </div>
                {matches.map((match) => <Match key={match.get('id')} match={match}/>)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/components/League.jsx